import { Component, OnInit } from '@angular/core';
import { BrandService } from '../brand/brand.service';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: [
    './_pfcss/bootstrap.min.css',
    './pagenotfound.component.css']
})
export class PagenotfoundComponent implements OnInit {

  brand = this.brandService.brand;
  constructor(private brandService: BrandService) { }
  currentYear = null;
  ngOnInit() {
    let currentTime = new Date();
    this.currentYear = currentTime.getFullYear();
  }

}
